import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowBoxRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-box-right, login, enter, door"><path d="M14.75 3.75L20.25 3.75V20.25H14.75M3.75 12L14 12M11.5 15.5L15 12L11.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowBoxRight;
